import React from 'react';
import PropTypes from 'prop-types';
import logoSrc from '../../../static/img/onboarding_logo.png';
import { FINISH_WITH_HUMAN_HREF_FALLBACK } from '../../config/constants';
import FinishWithHumanPill from './FinishWithHumanPill';

const BOOK_DEMO = { label: 'Book a Demo', href: FINISH_WITH_HUMAN_HREF_FALLBACK };

const OnboardingHeader = ({ showNav, showHumanPill }) => {
  return (
    <header className="hg-onboarding-header" data-testid="onboarding-header">
      <div className="hg-onboarding-header__awning">
        <div className="hg-onboarding-header__inner">
          <a href="/" className="hg-onboarding-header__logo" aria-label="HappyGuest home">
            <img src={logoSrc} alt="HappyGuest" />
          </a>

          {showHumanPill && <FinishWithHumanPill variant="inline" />}

          {showNav && !showHumanPill && (
            <nav className="hg-onboarding-header__nav" aria-label="Main">
              <a
                href={BOOK_DEMO.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hg-onboarding-header__nav-pill hg-onboarding-header__nav-pill--demo"
              >
                {BOOK_DEMO.label}
                <span className="hg-onboarding-header__arrow" aria-hidden="true">&#8599;</span>
              </a>
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

OnboardingHeader.propTypes = {
  showNav:       PropTypes.bool,
  showHumanPill: PropTypes.bool,
};

OnboardingHeader.defaultProps = {
  showNav:       true,
  showHumanPill: false,
};

export default OnboardingHeader;
